import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enModals from './locales/modals/en.json'
import esModals from './locales/modals/es.json'
import frModals from './locales/modals/fr.json'
import itModals from './locales/modals/it.json'
import deModals from './locales/modals/de.json'
import ptModals from './locales/modals/pt.json'
import enHomepage from './locales/homepage/en.json'
import esHomepage from './locales/homepage/es.json'
import frHomepage from './locales/homepage/fr.json'
import itHomepage from './locales/homepage/it.json'
import deHomepage from './locales/homepage/de.json'
import ptHomepage from './locales/homepage/pt.json'
import enLayouts from './locales/layouts/en.json'
import esLayouts from './locales/layouts/es.json'
import frLayouts from './locales/layouts/fr.json'
import itLayouts from './locales/layouts/it.json'
import deLayouts from './locales/layouts/de.json'
import ptLayouts from './locales/layouts/pt.json'
import enDashboard from './locales/dashboard/en.json'
import esDashboard from './locales/dashboard/es.json'
import frDashboard from './locales/dashboard/fr.json'
import itDashboard from './locales/dashboard/it.json'
import deDashboard from './locales/dashboard/de.json'
import ptDashboard from './locales/dashboard/pt.json'
import enAdminPortalUsers from './locales/admin-portal/users/en.json'
import esAdminPortalUsers from './locales/admin-portal/users/es.json'
import frAdminPortalUsers from './locales/admin-portal/users/fr.json'
import itAdminPortalUsers from './locales/admin-portal/users/it.json'
import deAdminPortalUsers from './locales/admin-portal/users/de.json'
import ptAdminPortalUsers from './locales/admin-portal/users/pt.json'
import enAdminPortalTeams from './locales/admin-portal/teams/en.json'
import esAdminPortalTeams from './locales/admin-portal/teams/es.json'
import frAdminPortalTeams from './locales/admin-portal/teams/fr.json'
import itAdminPortalTeams from './locales/admin-portal/teams/it.json'
import deAdminPortalTeams from './locales/admin-portal/teams/de.json'
import ptAdminPortalTeams from './locales/admin-portal/teams/pt.json'
import enAdminPortalApi from './locales/admin-portal/api/en.json'
import esAdminPortalApi from './locales/admin-portal/api/es.json'
import frAdminPortalApi from './locales/admin-portal/api/fr.json'
import itAdminPortalApi from './locales/admin-portal/api/it.json'
import deAdminPortalApi from './locales/admin-portal/api/de.json'
import ptAdminPortalApi from './locales/admin-portal/api/pt.json'
import enAdminPortalTeamMetrics from './locales/admin-portal/team-metrics/en.json'
import esAdminPortalTeamMetrics from './locales/admin-portal/team-metrics/es.json'
import frAdminPortalTeamMetrics from './locales/admin-portal/team-metrics/fr.json'
import itAdminPortalTeamMetrics from './locales/admin-portal/team-metrics/it.json'
import deAdminPortalTeamMetrics from './locales/admin-portal/team-metrics/de.json'
import ptAdminPortalTeamMetrics from './locales/admin-portal/team-metrics/pt.json'
import enAdminPortalOverwatch from './locales/admin-portal/overwatch/en.json'
import esAdminPortalOverwatch from './locales/admin-portal/overwatch/es.json'
import frAdminPortalOverwatch from './locales/admin-portal/overwatch/fr.json'
import itAdminPortalOverwatch from './locales/admin-portal/overwatch/it.json'
import deAdminPortalOverwatch from './locales/admin-portal/overwatch/de.json'
import ptAdminPortalOverwatch from './locales/admin-portal/overwatch/pt.json'
import enAdminPortalVerification from './locales/admin-portal/verification/en.json'
import esAdminPortalVerification from './locales/admin-portal/verification/es.json'
import frAdminPortalVerification from './locales/admin-portal/verification/fr.json'
import itAdminPortalVerification from './locales/admin-portal/verification/it.json'
import deAdminPortalVerification from './locales/admin-portal/verification/de.json'
import ptAdminPortalVerification from './locales/admin-portal/verification/pt.json'
import enOverwatch from './locales/overwatch/en.json'
import esOverwatch from './locales/overwatch/es.json'
import frOverwatch from './locales/overwatch/fr.json'
import itOverwatch from './locales/overwatch/it.json'
import deOverwatch from './locales/overwatch/de.json'
import ptOverwatch from './locales/overwatch/pt.json'
import enLiveTeam from './locales/liveTeam/en.json'
import esLiveTeam from './locales/liveTeam/es.json'
import frLiveTeam from './locales/liveTeam/fr.json'
import itLiveTeam from './locales/liveTeam/it.json'
import deLiveTeam from './locales/liveTeam/de.json'
import ptLiveTeam from './locales/liveTeam/pt.json'
import enAuth from './locales/auth/en.json'
import esAuth from './locales/auth/es.json'
import frAuth from './locales/auth/fr.json'
import itAuth from './locales/auth/it.json'
import deAuth from './locales/auth/de.json'
import ptAuth from './locales/auth/pt.json'
import enLegal from './locales/legal/en.json'
import esLegal from './locales/legal/es.json'
import frLegal from './locales/legal/fr.json'
import itLegal from './locales/legal/it.json'
import deLegal from './locales/legal/de.json'
import ptLegal from './locales/legal/pt.json'
import enTraining from './locales/training/en.json'
import esTraining from './locales/training/es.json'
import frTraining from './locales/training/fr.json'
import itTraining from './locales/training/it.json'
import deTraining from './locales/training/de.json'
import ptTraining from './locales/training/pt.json'
import enAbout from './locales/about/en.json'
import esAbout from './locales/about/es.json'
import frAbout from './locales/about/fr.json'
import itAbout from './locales/about/it.json'
import deAbout from './locales/about/de.json'
import ptAbout from './locales/about/pt.json'
import enEvidencePortal from './locales/evidence-portal/en.json'
import esEvidencePortal from './locales/evidence-portal/es.json'
import frEvidencePortal from './locales/evidence-portal/fr.json'
import itEvidencePortal from './locales/evidence-portal/it.json'
import deEvidencePortal from './locales/evidence-portal/de.json'
import ptEvidencePortal from './locales/evidence-portal/pt.json'
import enAlertPortal from './locales/alert-portal/en.json'
import esAlertPortal from './locales/alert-portal/es.json'
import frAlertPortal from './locales/alert-portal/fr.json'
import itAlertPortal from './locales/alert-portal/it.json'
import deAlertPortal from './locales/alert-portal/de.json'
import ptAlertPortal from './locales/alert-portal/pt.json'
import zhAlertPortal from './locales/alert-portal/zh.json'
import arAlertPortal from './locales/alert-portal/ar.json'
import jaAlertPortal from './locales/alert-portal/ja.json'

Vue.use(VueI18n)

const savedLocale = typeof localStorage !== 'undefined' ? localStorage.getItem('i911-locale') : null
const supportedLocales = ['en', 'es', 'fr', 'de', 'it', 'pt']
const initialLocale = savedLocale && supportedLocales.includes(savedLocale) ? savedLocale : 'en'

const messages = {
  en: { modals: enModals, homepage: enHomepage, layouts: enLayouts, dashboard: enDashboard, overwatch: enOverwatch, liveTeam: enLiveTeam, auth: enAuth, legal: enLegal, training: enTraining, about: enAbout, evidencePortal: enEvidencePortal, alertPortal: enAlertPortal, adminPortal: { users: enAdminPortalUsers, teams: enAdminPortalTeams, api: enAdminPortalApi, teamMetrics: enAdminPortalTeamMetrics, overwatch: enAdminPortalOverwatch, verification: enAdminPortalVerification } },
  es: { modals: esModals, homepage: esHomepage, layouts: esLayouts, dashboard: esDashboard, overwatch: esOverwatch, liveTeam: esLiveTeam, auth: esAuth, legal: esLegal, training: esTraining, about: esAbout, evidencePortal: esEvidencePortal, alertPortal: esAlertPortal, adminPortal: { users: esAdminPortalUsers, teams: esAdminPortalTeams, api: esAdminPortalApi, teamMetrics: esAdminPortalTeamMetrics, overwatch: esAdminPortalOverwatch, verification: esAdminPortalVerification } },
  fr: { modals: frModals, homepage: frHomepage, layouts: frLayouts, dashboard: frDashboard, overwatch: frOverwatch, liveTeam: frLiveTeam, auth: frAuth, legal: frLegal, training: frTraining, about: frAbout, evidencePortal: frEvidencePortal, alertPortal: frAlertPortal, adminPortal: { users: frAdminPortalUsers, teams: frAdminPortalTeams, api: frAdminPortalApi, teamMetrics: frAdminPortalTeamMetrics, overwatch: frAdminPortalOverwatch, verification: frAdminPortalVerification } },
  it: { modals: itModals, homepage: itHomepage, layouts: itLayouts, dashboard: itDashboard, overwatch: itOverwatch, liveTeam: itLiveTeam, auth: itAuth, legal: itLegal, training: itTraining, about: itAbout, evidencePortal: itEvidencePortal, alertPortal: itAlertPortal, adminPortal: { users: itAdminPortalUsers, teams: itAdminPortalTeams, api: itAdminPortalApi, teamMetrics: itAdminPortalTeamMetrics, overwatch: itAdminPortalOverwatch, verification: itAdminPortalVerification } },
  de: { modals: deModals, homepage: deHomepage, layouts: deLayouts, dashboard: deDashboard, overwatch: deOverwatch, liveTeam: deLiveTeam, auth: deAuth, legal: deLegal, training: deTraining, about: deAbout, evidencePortal: deEvidencePortal, alertPortal: deAlertPortal, adminPortal: { users: deAdminPortalUsers, teams: deAdminPortalTeams, api: deAdminPortalApi, teamMetrics: deAdminPortalTeamMetrics, overwatch: deAdminPortalOverwatch, verification: deAdminPortalVerification } },
  pt: { modals: ptModals, homepage: ptHomepage, layouts: ptLayouts, dashboard: ptDashboard, overwatch: ptOverwatch, liveTeam: ptLiveTeam, auth: ptAuth, legal: ptLegal, training: ptTraining, about: ptAbout, evidencePortal: ptEvidencePortal, alertPortal: ptAlertPortal, adminPortal: { users: ptAdminPortalUsers, teams: ptAdminPortalTeams, api: ptAdminPortalApi, teamMetrics: ptAdminPortalTeamMetrics, overwatch: ptAdminPortalOverwatch, verification: ptAdminPortalVerification } },
  zh: { alertPortal: zhAlertPortal },
  ar: { alertPortal: arAlertPortal },
  ja: { alertPortal: jaAlertPortal },
}

const i18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: 'en',
  messages,
})

export default i18n
